import styled from "@emotion/styled";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const StyledAdSlot = styled(AdSlot)`
  padding: 10px;
`;

export const Wrapper = styled.div`
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline: 24px;
  }
`;

export const Container = styled.div`
  ${setFullViewportWidthStyles()}

  ${props => props.theme.breakpoints.up("desktop")} {
    display: none;
  }
`;
